<template>
  <div>
    <div>
      <div class="smp ma-1 mt-4">
        <AdSmp />
        <SaveLayoutSmp
          :auto-save="autoSave"
          :last-save-time="lastSaveTime"
          :save="callSave"
          :saving="saving"
          style="width:100%;"
          @change="autoSave=$event"
        />
      </div>
      <div class="view-container">
        <div class="view-main">
          <div class="pb-4 px-3 mt-4 mx-2 mx-sm-5">
            <div
              class="d-flex mb-2 mt-2 mt-sm-4 align-center"
              style="font-size: 12px;"
            >
              <ListIcon
                :style="`color: ${accentColor};width:6px;height:7px`"
                class="mr-1 mb-1"
              />
              {{ currentNovel.name }} {{ currentNovelSiteTypeString }}
            </div>

            <v-layout
              :style="`height: 60px;background-color: ${backgroundColor}`"
              align-center
              class="ma-0 pa-0"
              d-flex
              justify-start
            >
              <div
                :style="`width:5px; height:100%;background-color:${accentColor}`"
                class="mr-4"
              />
              <div style="font-weight: bold;font-size: 18px;">
                プロット編集
              </div>
            </v-layout>
          </div>
          <div class="text-center">
            <v-progress-circular
              v-if="!filterPlots"
              indeterminate
              class="mx-auto"
              color="accent"
            />
          </div>
          <div class="mx-0 mx-sm-8">
            <div
              v-if="filterPlots && filterPlots.length>0"
              class="d-flex justify-end mr-sm-4 mr-2"
            >
              <v-btn
                class="mt-2 mb-4 "
                color="secondary"
                elevation="0"
                height="60"
                max-height="60"
                style="border-radius: 8px;font-size: 17px;font-weight: bold;"
                @click.prevent="createNewPlot(plots.length,true)"
              >
                新しいセクションを追加する
                <v-img
                  contain
                  max-height="22px"
                  max-width="22px"
                  src="../assets/plus_w.png"
                />
              </v-btn>
            </div>
            <div
              v-if="filterPlots && filterPlots.length==0"
              class="mb-5 px-3 mt-2"
            >
              <v-card
                class="mx-auto"
                height="420"
                style="padding-top:30px;padding-left:56px;padding-right:56px;background-color: var(--v-background2-base);"
                text
                width="440"
              >
                <v-img src="../assets/empty2.png" />
                <v-btn
                  color="secondary"
                  elevation="0"
                  height="60"
                  max-height="60"
                  style="margin-top:30px;border-radius: 8px;font-size: 17px;font-weight: bold"
                  width="100%"
                  @click.prevent="createNewPlot(0,true) ;createNewPlot(1,false)"
                >
                  <v-img
                    class="mr-3"
                    contain
                    max-height="22px"
                    max-width="22px"
                    src="../assets/file_w.png"
                  />
                  　新規追加する
                  <v-spacer />
                  <v-img
                    contain
                    max-height="22px"
                    max-width="22px"
                    src="../assets/plus_w.png"
                  />
                </v-btn>
              </v-card>
            </div>
            <Bubble
              v-if="filterPlots && filterPlots.length>0"
              text="ハンドルをドラッグ＆ドロップで並び替えができます"
            />
            <draggable
              v-model="plots"
              :options="{handle: '.item-handle'}"
            >
              <v-list-item
                v-for="(item,index) in plots"
                :key="item.order"
                :class="isShowButtonItem(item,index) ? `mx-4 pa-0 mb-6` :`mx-4 pa-0`"
                :style="`min-height: 0px;background-color:${cardBackgroundColor};`"
                dense
              >
                <DragHandle
                  v-if="item.section"
                  class="item-handle mx-0 px-2 mt-2"
                />
                <v-list-item-content
                  class="pr-4 ma-0 py-0 mt-3"
                >
                  <div
                    v-if="item.section"
                    class="border-area ma-0 pa-0 "
                  >
                    <div class="d-flex ma-0  mt-0 pa-0 pb-1 border-area align-center">
                      <v-text-field
                        v-model="item.name"
                        :background-color="cardBackgroundColor"
                        :maxlength="inputLength.section"
                        :style="{fontSize:fontSize*1.1+'px',fontWeight:'bold'}"
                        class="grey-text hide-details ma-0 pa-0"
                        dense
                        flat
                        label="セクションを入力する"
                        single-line
                      />
                      <v-btn
                        icon
                        @click="deleteConfirm(item)"
                      >
                        <DeleteIcon class="ml-2" />
                      </v-btn>
                    </div>
                  </div>

                  <div
                    v-if="!item.section"
                    :style="`background-color:${backgroundColor};`"
                    class="d-flex mx-4 my-2 pa-0 "
                  >
                    <DragHandle class="item-handle mx-0 px-2 mt-4" />
                    <v-textarea
                      v-model="item.content"
                      color="text"
                      :background-color="backgroundColor"
                      :class="'linespace'+lineSpaceSize+' normal-text-area-'+fontSizeIndex"
                      :maxlength="inputLength.description"
                      auto-grow
                      counter
                      dense
                      flat
                      label="プロットを入力する"
                      solo
                    />
                    <v-btn
                      icon
                      @click.prevent="deleteConfirm(item)"
                    >
                      <DeleteIcon class="ml-2" />
                    </v-btn>
                  </div>
                  <div
                    v-if="isShowButtonItem(item,index)"
                    class="d-flex justify-end mr-sm-4 mr-2"
                  >
                    <v-btn
                      class="mt-2 mb-4"
                      color="secondary"
                      elevation="0"
                      height="60"
                      max-height="60"
                      style="border-radius: 8px;font-size: 17px;font-weight: bold"
                      @click.prevent="createNewPlot(index+1,false)"
                    >
                      <v-img
                        class="mr-3"
                        contain
                        max-height="22px"
                        max-width="22px"
                        src="../assets/siori.png"
                      />
                      新しいプロットを追加する
                      <v-img
                        class="ml-4"
                        contain
                        max-height="22px"
                        max-width="22px"
                        src="../assets/plus_w.png"
                      />
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </draggable>
          </div>
        </div>
        <div
          :class="`view-right-menu pc ${hideAppbar ? '':'smallarea'}`"
        >
          <SaveLayoutPc
            :auto-save="autoSave"
            :last-save-time="lastSaveTime"
            :save="callSave"
            :saving="saving"
            @change="autoSave=$event"
          />
          <div style="height: 100%;">
            <div
              v-if="!isPremium"
            >
              <AdPc />
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog
      v-model="deleteDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          削除確認
        </v-card-title>
        <v-card-text v-if="deleteItemData!=null">
          指定の{{ deleteItemData.section ? 'セクション' : 'プロット' }}を削除してもよろしいですか？
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="deleteDialog = false"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="deleteItem(deleteItemData)"
          >
            削除
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapState} from "vuex";
import clonedeep from 'lodash.clonedeep'
import draggable from "vuedraggable";
import config from "@/const"
import AdSmp from '../component/AdSmp.vue';
import AdPc from '../component/AdPc.vue';
import DeleteIcon from "@/component/svg/DeleteIcon";
import Bubble from "@/component/Bubble";
import DragHandle from "@/component/DragHandle";
import SaveLayoutPc from '../component/SaveLayoutPc.vue';
import SaveLayoutSmp from '../component/SaveLayoutSmp.vue';
import firebase from "firebase/app";
import axios from "axios";
import ListIcon from "@/component/svg/ListIcon";

export default {
  name: "Plot",
  components: {
    draggable,
    AdSmp,
    AdPc,
    DeleteIcon,
    Bubble,
    DragHandle,
    SaveLayoutPc,
    SaveLayoutSmp,
    ListIcon
  },
  data() {
    return {
      inputLength: config.INPUT_LENGTH.plot,
      deleteDialog: false,
      deleteItemData: null,
      saving: false,
      saver: null,
      plots: null,
      basePlots: null,
      saveTimer: null,
      autoSave: null,
      accentColor: null,
      backgroundColor: null,
      cardBackgroundColor: null,
      lastSaveTime: null,
      filterPlots: null,
      novelId: config.HASH_IDS.decode(this.$route.params.novelid)[0],
      currentNovel: null,
      currentNovelSiteTypeString: null,
    }
  },
  created() {
    window.addEventListener("beforeunload", this.leaveHandler)
  },
  destroyed() {
    window.removeEventListener("beforeunload", this.leaveHandler)
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasDiff()) {
      // アラートダイアログを表示して、結果に応じて遷移
      const msg = "編集した内容が保存されていません。遷移しますか？";
      const answer = window.confirm(msg);
      next(answer);
    } else {
      // next()は必ず呼び出さないといけない
      next();
    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
    this.backgroundColor = this.$vuetify.theme.dark ? 'black' :
        'white'
    this.cardBackgroundColor = this.$vuetify.theme.dark ? '#050507' : '#fafaf8'
    if (localStorage.autoSave != null && localStorage.autoSave != undefined) {
      this.autoSave = localStorage.autoSave == "true";
    } else {
      this.autoSave = true;
    }
  },
  methods: {
    leaveHandler(event) {
      // 入力と保存に差分があったらブラウザのダイアログ
      if (this.hasDiff()) {
        event.preventDefault();
        event.returnValue = "編集した内容が保存されていません。遷移しますか？";
      }
    },
    isShowButtonItem(item, index) {
      if (index == this.plots.length - 1) {
        return true
      }
      let nextIndex = -1
      for (let i = index + 1; i < this.plots.length; i++) {
        nextIndex = i;
        break;
      }
      return nextIndex == -1 || this.plots[nextIndex].section
    },
    callSave() {
      this.saver = 'saving'
    },
    createNewPlot(orderIndex, section) {
      const newData = {
        id: null,
        content: "",
        name: "",
        section: section,
        novelId: config.HASH_IDS.decode(this.$route.params.novelid)[0],
        orderIndex: orderIndex,
        usertoken: null,
        modifiedTimestamp: null,
        filterPlots: null
      };
      this.plots.splice(orderIndex, 0, newData)
    },
    deleteConfirm(deleteItemData) {
      this.deleteItemData = deleteItemData;
      this.deleteDialog = true;
    },
    // 削除実行
    async deleteItem(deleteItemData) {
      if (!deleteItemData.id) {
        this.plots = this.plots.filter((element) => element != deleteItemData)
        this.deleteDialog = false;
        return
      }
      const user = firebase.auth().currentUser
      const token = await user.getIdToken(false)
      if (token == null) {
        return
      }
      // console.log("token="+token)
      const ret = await axios.delete(config.API_URL + "auth/plot/" + deleteItemData.id, {
        headers: {"X-Firebase-Auth": token},
        data: {}
      })
      this.plots = this.plots.filter((element) => element != deleteItemData)
      this.basePlots = this.plots
      this.deleteDialog = false;	// 最後に削除確認ダイアログは閉じます。
    },
    hasDiff() {
      if(!this.basePlots && this.plots){
        return true
      }
      if (this.basePlots.length != this.plots.length) {
        return true
      }
      for (let index = 0; index < this.basePlots.length; index++) {
        if (this.basePlots[index].content != this.plots[index].content) {
          return true
        }
        if (this.basePlots[index].name != this.plots[index].name) {
          return true
        }
        if (this.basePlots[index].orderIndex != this.plots[index].orderIndex) {
          return true
        }
      }
      return false
    },
    async reloadItems() {
      const user = firebase.auth().currentUser
      const token = await user.getIdToken(false)
      if (token == null) {
        return
      }
      // console.log("token="+token)
      const ret = await axios.get(config.API_URL + "auth/plots", {
        headers: {"X-Firebase-Auth": token},
        params: {
          "novelId": config.HASH_IDS.decode(this.$route.params.novelid)[0]
        },
        data: {}
      })

      this.plots = ret.data
      this.basePlots = clonedeep(this.plots).sort((a, b) => {
        return a.orderIndex - b.orderIndex
      })
    }
  },
  computed: {
    ...mapState({
      user: state => state.userModule.user,
      fontSize: state => state.userModule.user.writerFontSizeTypeKeyValue.size * 13,
      fontSizeIndex: state => state.userModule.user.writerFontSizeTypeKeyValue.value,
      lineSpaceSize: state => state.userModule.user.writerLineSpaceTypeKeyValue.value,
      isPremium: state => state.userModule.isPremium,
      hideAppbar:state=>state.userModule.hideTopBottomMode
    }),
  },
  watch: {
    autoSave(newName) {
      localStorage.autoSave = newName;
      if (localStorage.autoSave && this.hasDiff()) {
        this.callSave()
      }
    },
    $route: {
      handler: function () {
        this.novelId = config.HASH_IDS.decode(this.$route.params.novelid)[0]

        this.currentNovel = this.$store.state.NovelListModule.NovelList.find(element => element.id == this.novelId)
        if (this.currentNovel) {
          this.currentNovelSiteTypeString = config.siteTypeString(this.currentNovel.targetSite)
        }
        this.reloadItems()
      },
      immediate: true
    },
    plots: {
      handler: function (val, oldVal) {
        this.filterPlots = this.plots
        if (this.autoSave) {
          if (this.hasDiff()) {
            if (this.saveTimer != null) {
              clearTimeout(this.saveTimer)
            }
            this.saveTimer = setTimeout(this.callSave, config.AUTO_SAVE_TIME)
          }
        }
      },
      deep: true
    },
    async saver() {
      if (this.saver != null) {
        this.saveTimer = null
        const l = this.saver
        this[l] = !this[l]
        const saveValues = clonedeep(this.plots)
        const user = firebase.auth().currentUser
        const token = await user.getIdToken(false)
        if (token == null) {
          return
        }
        var index = 0
        var hasNewItem = false
        saveValues.forEach(function (item) {
          item.orderIndex = index
          index += 1
          item.modifiedTimestamp = Date.now()
          item.updateDate = Date.now()
          if (item.createdDate == undefined) {
            hasNewItem = true
            item.createdDate = Date.now()
          }
        })
        await axios.post(config.API_URL + "auth/plots", saveValues, {
          headers: {"X-Firebase-Auth": token, "fromWeb": true},
        })
            .then(value => {
              if (hasNewItem) {
                this.reloadItems()
              } else {
                this.plots = saveValues
                this.basePlots = clonedeep(this.plots)
              }
              this.lastSaveTime = Date.now()
              this[l] = false
              this.saver = null
            }).catch(reason => {
              alert("保存中にエラーが発生しました。もう一度保存してください")
              this[l] = false
              this.saver = null
            });
      }
    }
  }
}
</script>

<style>
.border-area {
  border-bottom: 2px solid var(--v-bordercolor-base);
}

.flex-container > :first-child {
  margin-right: auto;
}
</style>
